import * as React from 'react';
import { Row, Col, Button, Tabs, Input } from 'antd';
import TableFilterContextProvider from 'components/Forms/DataGrid/TableFilterContextProvider';
import { DashboardViewCard } from '.';
import { RouteComponentProps, NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';
import { BannerDiv, OfferingCardClasses, DashboardTitle, STabCardDiv } from './DashboardView.Style';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import Title from 'antd/lib/typography/Title';
import Search from 'antd/lib/input/Search';
import { BrandedButton } from '../../Styled/Branded/BrandedButton'

import HeaderLogoImg from '../../../../assets/images/header_logo.png';
import LogoImg from '../../../assets/images/dashboard-logo.png';

const { TabPane } = Tabs;

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State { }

export class DashboardViewWithoutRouter extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <TableFilterContextProvider>
                <Row>
                    <Col xs={{ span: 24 }} lg={{ span: 22, offset: 1 }} style={{ backgroundColor: '#000' }}>
                        <BannerDiv>
                            <Row style={{ height: '100%' }}>
                                <Col xs={{ span: 10, offset: 11 }} md={{ span: 8, offset: 14 }} lg={{ span: 7, offset: 15 }} xxl={{ span: 7, offset: 16 }} style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <DashboardTitle style={{ color: '#3d3d3c' }}><img className='dashboard-logo' src={LogoImg } /></DashboardTitle>
                                    </div>
                                </Col>
                            </Row>
                        </BannerDiv>
                    </Col>
                </Row>
                <OfferingCardClasses>
                    <Row>
                        <Col xs={{ span: 24 }} sm={{ span: 22, offset: 1 }} style={{ backgroundColor: 'white', padding: '45px'}} className='xs-no-padding'>
                            <Row>
                                <Col xs={24} sm={12} >
                                    <Title level={3} style={{ color: '#202020' }}>Current IPO Offers</Title>
                                </Col>
                                <Col style={{ textAlign: 'right' }} xs={24} sm={12} >
                                    <NavLink to={'/ipo'}><Title style={{ color: '#202020' }} level={4}>View All Offers -&gt;</Title></NavLink>
                                </Col>
                            </Row>
                            <DashboardViewCard {...this.props} />

                        </Col>
                    </Row>
                </OfferingCardClasses>
            </TableFilterContextProvider>
        );
    }
}

const DashboardView = withRouter(DashboardViewWithoutRouter);

export default DashboardView;

